import { z } from "zod";

export const contactSchema = z.object({
    id: z.number().nullish(),
    hubspotId: z.number().nullish(),
    hubspotCompanyId: z.number().nullish(),
    firstName: z.string().nullish(),
    lastName: z.string().nullish(),
    email: z.string(),
    phoneNumber: z.string().nullish(),
    address: z.string().nullish(),
    zipCode: z.string().nullish(),
    city: z.string().nullish(),
    message: z.string().nullish(),
});

export const contactResponseSchema = z.object({
    getContact: contactSchema,
});
